const currencies = [
  { label: 'GBP', sing: '£', name: 'Pound Sterling' },
  { label: 'JPY', sign: '¥', name: 'Japanese Yen' },
  { label: 'SEK', sign: 'kr', name: 'Swedish Krona' },
  { label: 'NOK', sign: 'kr', name: 'Norwegian Krone' },
  { label: 'TRY', sign: '₺', name: 'Turkish Lira' },
  { label: 'BRL', sign: 'R$', name: 'Brazilian Real' },
  { label: 'RUB', sign: '₽', name: 'Russian Ruble' },
  { label: 'UAH', sign: '₴', name: 'Ukrainian Hryvnia' },
  { label: 'CNY', sign: '¥', name: 'Chinese Yuan' },
  { label: 'EUR', sign: '€', name: 'Euro' },
  { label: 'PLN', sign: 'zł', name: 'Polish Złoty' },
  { label: 'RON', sign: 'lei', name: 'Romanian Leu' },
  { label: 'AED', sign: 'د.إ', name: 'United Arab Emirates Dirham' },
  { label: 'THB', sign: '฿', name: 'Thai Baht' },
  { label: 'INR', sign: '₹', name: 'Indian Rupee' },
  { label: 'PEN', sign: 's/.', name: 'Peruvian sol' },
];

const allCurrencies = [
  ...currencies,
  { label: 'USD', sing: '$', name: 'United States Dollar' },
  { label: 'NGN', sign: '' },
  { label: 'TMT', sign: '' },
  { label: 'USDT', sign: '' },
  { label: 'BTC', sign: '' },
]

export default process.env.PRESENTATION ? currencies : allCurrencies;
